export const getUpsellGroupsState = (state) => state.upsellGroups;
export const getUpsellGroupState = (state) => state.upsellGroup;
export const getUpsellGroupInitiatingItemsState = (state) => state.upsellGroupInitiatingItems;
export const getSmartUpsellGroupInitiatingItemsState = (state) =>
  state.smartUpsellGroupInitiatingItems;
